

const makeQueryString = jsonObject => {
    let queryString = "?"
    let qryStr = ""
    for (var dbTypedbSchemaTableKey in jsonObject) {
        if (jsonObject[dbTypedbSchemaTableKey] != undefined) {
            qryStr = encodeURIComponent(jsonObject[dbTypedbSchemaTableKey].toString());
            queryString += `${dbTypedbSchemaTableKey}=${qryStr}&`;
        }
    }
    queryString = queryString.slice(0, -1)
    return queryString
};

const setQueries = (route, operationCondi, defaultCondition) => {
    for (const dbTypedbSchemaTableKey in defaultCondition)
        operationCondi[dbTypedbSchemaTableKey] = route?.query[dbTypedbSchemaTableKey] || defaultCondition[dbTypedbSchemaTableKey];
};

const setQueriesNoRoute = (operationCondi, defaultCondition) => {
    Object.assign(operationCondi, defaultCondition);
};

const setCondiChanged = (operationCondiCheck, newVal, oldVal) => {
    for (const dbTypedbSchemaTableKey in operationCondiCheck.flag){
        operationCondiCheck.flag[dbTypedbSchemaTableKey] = newVal[dbTypedbSchemaTableKey] !== operationCondiCheck.value[dbTypedbSchemaTableKey];
        operationCondiCheck.value[dbTypedbSchemaTableKey] = newVal[dbTypedbSchemaTableKey];
    }
};

const setCondiClear = (operationCondiCheck, oldVal) => {
    for (const dbTypedbSchemaTableKey in operationCondiCheck.value)
        operationCondiCheck.value[dbTypedbSchemaTableKey] = oldVal[dbTypedbSchemaTableKey]
    for (const dbTypedbSchemaTableKey in operationCondiCheck.flag)
        operationCondiCheck.flag[dbTypedbSchemaTableKey] = false
};

const changeCondi = (operationCondiCheck, operationCondi) => {
    for (const dbTypedbSchemaTableKey in operationCondiCheck.value)
        operationCondi[dbTypedbSchemaTableKey] = operationCondiCheck.value[dbTypedbSchemaTableKey]
};

const checkCondiWithoutPageNum = (operationCondiCheck) => {
    let ret = false;
    for (const dbTypedbSchemaTableKey in operationCondiCheck.flag) {
        if (dbTypedbSchemaTableKey === "pageNum")
            continue;
        ret = ret || operationCondiCheck.flag[dbTypedbSchemaTableKey]
    }
    return ret
};


export { makeQueryString, setQueries, setQueriesNoRoute, setCondiChanged, setCondiClear, changeCondi, checkCondiWithoutPageNum }

